import { connect } from 'react-redux';
import NewsNew from './NewsNew';
import newsCRUDAction from '../../../actions/news';

export default connect(
  undefined,
  dispatch => ({
    fetch: () => dispatch(newsCRUDAction.createModel())
  })
)(NewsNew);




// WEBPACK FOOTER //
// ./src/components/News/NewsNew/index.js